import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';
import * as pako from 'pako';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  // GetEmpDetailsFordailyAttendanceGetData(Detail: any) {
  //   return this.http.post<any>(environment.API_URL + `GetEmpDetailsFordailyAttendance/GetData`,
  //     this.session.SetClass(Detail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }

  AttendanceDashboardGetData(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AttendanceDashboard/GetData`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  AttendanceDashboardGzipGetData(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AttendanceDashboardGzip/GetData`,
      this.session.SetClass(Detail),
    ).pipe(map(response => {
      // if (response.Error_Code == '11' || response.Error_Code == '02') {
      //   this.session.End();
      //   return response
      // } else {
      //const compressedBytes = new Uint8Array(response.match(/.{1,2}/g).map((byte: string) => parseInt(byte, 16)));
      
      return response;
      //}
    }));
  }

  AttendanceDashboardGzipGetDataTest(Detail: any) {
    return this.http.post<any>(environment.API_URL + `AttendanceDashboardGzip_test/GetData`,
      this.session.SetClass(Detail),
    ).pipe(map(response => {
      // if (response.Error_Code == '11' || response.Error_Code == '02') {
      //   this.session.End();
      //   return response
      // } else {
      //const compressedBytes = new Uint8Array(response.match(/.{1,2}/g).map((byte: string) => parseInt(byte, 16)));
      
      return response;
      //}
    }));
  }

  ESS_AttendanceDashboardGetData(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AttendanceDashboard/GetData`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_AttendanceDashboardGetDataRevised(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_AttendanceDashboardGetData/Revised`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_FillComboForAttendanceDashboard(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_FillComboForAttendance/Dashboard`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
